import type {
  MinimalDevice,
  MinimalDeviceImportanceEnum,
} from '@rtkwlf/asset-data-service';

const TOTAL_DEVICES = 50;

const importanceList = [
  'unassigned',
  'none',
  'critical',
  'high',
  'medium',
  'low',
];

export const device: MinimalDevice = {
  category: 'server',
  legacyDeviceIds: ['string'],
  id: 'b2bdaee5-6f13-4867-b204-19637',
  importance: 'unassigned',
  lastSeenTime: new Date('2021-01-01T17:32:28Z'),
  name: 'aws:085957942246',
  networkInterfaces: [
    {
      ipAddresses: ['192.168.1.2'],
      mac: '00:00:5e:00:53:af',
      name: 'eth0',
    },
  ],
  netbios: 'aws.netbios',
  hostname: 'my.hostname',
  os: {
    name: 'CentOS',
    version: '',
    type: 'linux',
  },
  sources: ['agent'],
  tags: [
    'tag',
    'a tag',
    'this is a long tag name, please truncate me',
    'one tag',
    'a',
    'b',
    'c',
  ],
  risk: {
    count: 1,
    score: 1.2,
    lastSuccessfulScanned: {
      agent: new Date('2024-01-01T17:32:28Z'),
    },
  },
};

export const mockDevices = Array<MinimalDevice>(TOTAL_DEVICES)
  .fill(device)
  .map<MinimalDevice>((item, index) => {
    const riskScore = item.risk?.score ? item.risk.score + index * 0.2 : 0;

    return {
      ...item,
      id: item.id + index,
      importance: importanceList[index % 6] as MinimalDeviceImportanceEnum,
      name: item.name ? item.name + index : '',
      risk: {
        score: Math.min(10, riskScore),
        count: item.risk?.count ? item.risk.count + index : 0,
        lastSuccessfulScanned: {
          agent: new Date('2024-01-01T17:32:28Z'),
        },
      },
    };
  });
